export default function popZendeskWidget() {
  document.addEventListener("click", function (event) {
    if (!event.target.closest(".pop-zendesk-widget")) return
    openWidget(event)
  })
}

function openWidget(e) {
  if (window.App.platformSupportEntitled) {
    e.preventDefault()
    window.App.loadZendeskMessenger()
  }
}
